<h2 mat-dialog-title class="ord-modal-title">
  <mat-icon
    svgIcon="overdue"
    class="ord-icon ord-icon-xl ord-text-red"
  ></mat-icon>
  Subscription Required
</h2>

<mat-dialog-content class="ord-modal-content">
  @if (!loading()) {
  <!-- message to admin users -->
  @if (currentUserRole() === Role.ADMIN) {
  <div>
    <!-- no previous subscription -->
    @if( hasNoPreviousSubscription()) {
    <p>
      You don't have an active subscription yet. Please select a plan to
      continue using Orderna.
    </p>
    <!-- unpaid subscription -->
    } @else if (hasUnpaidSubscription()){
    <p>
      Your last subscription payment for the
      <span class="font-bold"> {{ lastPlanName() }} </span>
      plan was not completed. To regain access, please settle the payment or
      select a different plan.
    </p>
    <!-- inactive plan -->
    } @else if (hasInactivePlan()) {
    <p>
      Your previous
      <span class="font-bold"> {{ lastPlanName() }} </span>
      plan has been deactivated and is no longer available. Please select a new
      plan to continue using Orderna.
    </p>
    <!-- overdue subscription -->
    } @else if(hasOverdueSubscription()) {
    <p>
      Your subscription to the
      <span class="font-bold"> {{ lastPlanName() }} </span>
      plan expired
      {{
        lastPlan()!.daysOverdue | i18nPlural : dayPluralMapping
      }}
      (on {{ lastPlan()!.endDate | date : "longDate" }}).
      Please renew your subscription or select a different plan to regain
      access.
    </p>
    }
  </div>

  <!-- select plan form -->
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="grid grid-cols-1 sm:gap-x-4 my-6"
  >
    <!-- plan interval filter -->
    <app-chips-toggle
      class="mb-2"
      [value]="planIntervalFilter()"
      [options]="PLAN_INTERVAL_OPTIONS"
      (selectionChange)="onPlanIntervalFilterChanged($event)"
    />
    <!-- filtered plans -->
    <div [class]="{ hidden: filteredPlans().length === 0 }">
      <ul class="space-y-2 mb-4 text-black">
        @for(plan of filteredPlans(); track plan.id) {
        <li class="pr-1">
          <button
            type="button"
            class="w-full h-full text-left py-3 px-4 rounded bg-white dark:bg-slate-800 border-2 shadow-sm duration-150 ease-in-out"
            [class.border-indigo-500]="selectedPlan?.id === plan.id"
            (click)="form.controls.planId.setValue(plan.id!)"
          >
            <div class="space-y-1">
              <div class="grid grid-cols-1 sm:grid-cols-5 items-center gap-2">
                <div class="flex gap-1 items-center">
                  <!-- plan icon -->
                  <div
                    class="w-4 h-4 rounded-full shrink-0 bg-gradient-to-tr"
                    [ngClass]="{
                      'from-emerald-500 to-emerald-300':
                        plan.type === PlanType.BASIC,
                      'from-sky-500 to-sky-500':
                        plan.type === PlanType.STANDARD,
                      'from-indigo-500 to-indigo-500':
                        plan.type === PlanType.PLUS
                    }"
                  >
                    <svg
                      class="w-4 h-4 fill-current text-white"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M12 17a.833.833 0 01-.833-.833 3.333 3.333 0 00-3.334-3.334.833.833 0 110-1.666 3.333 3.333 0 003.334-3.334.833.833 0 111.666 0 3.333 3.333 0 003.334 3.334.833.833 0 110 1.666 3.333 3.333 0 00-3.334 3.334c0 .46-.373.833-.833.833z"
                      />
                    </svg>
                  </div>
                  <!-- plan type -->
                  <span class="ord-subtitle-2">{{
                    plan.type | capitalize
                  }}</span>
                </div>
                <!-- plan price -->
                <div class="sm:col-start-4 sm:col-span-2">
                  <span class="ord-body-2">₱</span>
                  <span class="ord-subtitle-2">{{ plan.price }}</span>
                  <span class="ord-text-gray ord-body-2">{{
                    planIntervalMapping[plan.interval]
                  }}</span>
                </div>
              </div>
              <!-- plan description -->
              <div class="ord-text-gray ord-body-2">
                {{ plan.description }}
              </div>
            </div>
          </button>
        </li>
        }
      </ul>
      <!-- payment method -->
      <app-input-select
        id="payment-method"
        label="Payment Method"
        controlName="paymentMethod"
        placeholder="Select payment method"
        [options]="PAYMENT_TYPE_OPTIONS"
        [validators]="[Validators.required]"
      />
    </div>
    <div
      class="flex flex-col justify-center items-center text-center ord-text-gray my-12"
      [class]="{ hidden: filteredPlans().length > 0 }"
    >
      <span class="font-bold">No plans available.</span>
      <span>
        Please try adjusting the billing interval filter, or contact our support
        team for assistance.
      </span>
    </div>
  </form>
  <!-- message to non-admin users -->
  } @else {
  <p>Your company's current subscription is no longer active or eligible.</p>
  <p>
    Please contact your administrator to resolve the issue and restore access.
  </p>
  } } @else {
  <div class="flex justify-center">
    <mat-progress-spinner mode="indeterminate" />
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="ord-modal-actions">
  @if(errorMessages() && errorMessages().length > 0) {
  <app-error-list class="ord-modal-errors" [errorMessages]="errorMessages()" />
  } @if (filteredPlans().length > 0) {
  <app-button
    (btnClick)="onSubmit()"
    [disabled]="form.invalid || loading()"
    [svgIcon]="loading() ? 'loading' : undefined"
  >
    <ng-template appButtonText> {{ submitButtonText }}</ng-template>
  </app-button>
  }
</mat-dialog-actions>
